// extracted by mini-css-extract-plugin
export var blue = "_1c-f";
export var brand = "_1c-b";
export var darkGrey = "_1c-e";
export var disabled = "_1c-4";
export var disabledSubtle = "_1c-5";
export var error = "_1c-6";
export var green = "_1c-g";
export var grey = "_1c-d";
export var icon = "_1c-0";
export var inherit = "_1c-a";
export var lightGrey = "_1c-c";
export var orange = "_1c-i";
export var pink = "_1c-k";
export var primary = "_1c-1";
export var purple = "_1c-l";
export var red = "_1c-j";
export var secondary = "_1c-2";
export var success = "_1c-9";
export var tertiary = "_1c-3";
export var warning = "_1c-7";
export var warningSecondary = "_1c-8";
export var white = "_1c-m";
export var yellow = "_1c-h";